import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import { AuthGuard } from "./features/auth/components/AuthGuard";
import { authRoutes } from "./features/auth/routes";
import { mentorRoutes } from "./features/mentor/routes";
import { Layout } from "./features/shared/components/Layout";

function App() {
  return (
    <Routes>
      {/* Public routes */}
      {authRoutes}

      {/* Protected routes wrapper */}
      <Route element={<AuthGuard />}>
        {/* Default redirect */}
        <Route index element={<Navigate to="/mentor" replace />} />

        {/* Mentor routes with Layout */}
        <Route
          path="mentor"
          element={
            <Layout>
              <Outlet />
            </Layout>
          }
        >
          {mentorRoutes}
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
